export { default as StatisticsSection } from './StatisticsSection';
